import React from 'react';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Base from './components/Base';
import Button from './components/Button';
import FormControl from './components/FormControl';
import Input from './components/Input';
import List from './components/List';
import Paragraph from './components/Paragraph';

/**
 * @deprecated Use Skeleton in shared component library
 */
const Skeleton = ({
  visible = false,
  children = null,
  type = 'Base',
  ...props
}) => {
  if (!visible) {
    return typeof children === 'function' ? children() : children;
  }

  const SelectedSkeleton = {
    Base,
    Input,
    FormControl,
    Button,
    List,
    Paragraph,
    Hide: () => <Box display="none" />,
  }[type];

  return (
    <SelectedSkeleton
      {...props} // eslint-disable-line react/jsx-props-no-spreading
    />
  );
};

Skeleton.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  type: PropTypes.string,
};

export default Skeleton;
